<template>
  <div>
    <div align="left"></div>
    <br />
    <div class="text-left">
      <h5 class="font-weight-bold text-primary">Payment Limitation</h5>
      <b-row class="mt-4">
        <b-col md="4" class="my-1">
          <b-form-group class="mb-0">
            <b-input-group>
              <b-form-input v-model="filter" placeholder="Search"></b-form-input>
              <b-input-group-append>
                <b-button variant="primary" :disabled="!filter" @click="filter = ''">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="2" class="my-1" align="right">
          <b-form-group label-cols-sm="6" label="Show" class="mb-0">
            <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="3" class="my-1"></b-col>
        <b-col md="3" class="my-1" align="right">
          <b-button variant="primary" @click="showModalFormPaymentLimitation('create', '')">
            <img src="@/assets/create-new.svg" class="mr-2" alt />Create New
          </b-button>
        </b-col>
      </b-row>
      <br />
      <b-table
        responsive
        show-empty
        ref="paymentLimitationTable"
        :items="getDataPaymentLimitation"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        head-variant="light"
        class="bg-white"
      >
        <div slot="table-busy" class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
        <template v-slot:cell(username)="{ item }">
          <p class="mb-0">{{item.username}}</p>
        </template>
        <template v-slot:cell(amount_limit)="{ item }">
          <p class="mb-0">{{item.amount_limit | rupiah}}</p>
        </template>
        <template v-slot:cell(reached_max)="{ item }">
          <p class="mb-0">{{item.amount_used >= item.amount_limit ? 'Yes': 'No'}}</p>
        </template>
        <template v-slot:cell(action)="{item}">
          <b-row class="row">
            <div class="col-md-4">
              <b-link v-b-tooltip.hover title="Edit" class="text-dark"
                @click="showModalFormPaymentLimitation('edit', item.id)">
                <img src="@/assets/ic-edit.svg" class="mr-2" alt />
              </b-link>
            </div>
            <div class="col-md-4">
              <b-link v-b-tooltip.hover title="Delete" class="text-dark"
                @click="deletePaymentLimitation(item.id, item.username)">
                <img src="@/assets/rectangle.svg" class="mr-2" alt />
              </b-link>
            </div>
          </b-row>
        </template>
      </b-table>
      <b-row class="mx-auto">
        <b-col md="4" align="left" class="mx-auto px-0">
          <div v-if="totalRows == 0 || totalRows == null">
            Showing 0 Records
          </div>
          <div v-else>
            Showing {{ fromPage[currentPage - 1] }} to
            {{ toPage[currentPage - 1] }} of {{ totalRows }} Records
          </div>
        </b-col>
        <b-col md="4" class="mx-auto"></b-col>
        <b-col md="4" align="right" class="px-0">
          <b-pagination align="right" v-model="currentPage" :total-rows="totalRows" :per-page="perPage"
            class="my-0"></b-pagination>
        </b-col>
      </b-row>
    </div>
    <b-modal v-model="modalFormPaymentLimitationShow" size="sm" hide-header hide-footer no-close-on-esc no-close-on-backdrop>
      <div class="container">
        <b-row>
          <b-col>
            <h4 class="font-weight-bold">{{ editModal ? 'Edit' : 'Create' }} Claim Limit</h4>
          </b-col>
        </b-row>
        <br />
        <b-row>
          <b-col>
            <b-form-group
              id="fieldset-1"
              label-class="control-label"
              class="font-weight-bold required"
              label="Username"
              label-for="username"
              style="font-size: 12px"
            >
              <b-form-select
                v-model="payment_limitation.user_id"
                v-validate="'required'"
                name="username"
                data-vv-as="Username"
                id="username"
                class="form-control"
                v-on:change="updateUser($event)"
                :disabled="editModal"
              >
                <template v-slot:first>
                  <option value disabled>-- Pilih --</option>
                </template>
                <option v-for="claim_user in claim_users" :key="claim_user.Id" :value="claim_user.Id">{{claim_user.username}}</option>
              </b-form-select>
              <p style="width: 100%; font-size: 80%;color: #dc3545;">
                {{ veeErrors.first("username") }}
              </p>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group
              id="fieldset-1"
              label="Claim Payment Limit"
              label-class="control-label"
              class="font-weight-bold required"
              label-for="amount-limitation"
            >
              <b-input-group>
                <b-input-group-prepend>
                  <b-button variant="light" class="custom-input-group-prepend"
                    :class="{
                      'is-invalid': veeErrors.has('amount_limitation'),
                      'is-valid': $validator.fields.find({ name: 'amount_limitation' }) &&
                                  $validator.fields.find({ name: 'amount_limitation' }).flags.dirty && 
                                  !veeErrors.has('amount_limitation'),
                    }">
                  Rp
                  </b-button>
                </b-input-group-prepend>
                <input
                  v-model="payment_limitation.amount_limit"
                  v-validate="'required'"
                  name="amount_limitation"
                  data-vv-as="Claim Payment Limit"
                  id="amount-limitation"
                  class="form-control"
                  placeholder="Claim Payment Limit"
                  onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                />
              </b-input-group>
              <p style="width: 100%; font-size: 80%;color: #dc3545;">
                {{ veeErrors.first("amount_limitation") }}
              </p>
            </b-form-group>
          </b-col>
        </b-row>
        <br />
        <b-row>
          <b-col>
            <b-button variant="light" :disabled="loadingFormPaymentLimitation"
              @click="modalFormPaymentLimitationShow = !modalFormPaymentLimitationShow" class="text-primary" block
              size="lg">Close</b-button>
          </b-col>
          <b-col>
            <b-button v-if="payment_limitation.id != ''" variant="primary" :disabled="loadingFormPaymentLimitation"
              @click="updatePaymentLimitation()" block size="lg">
              <b-spinner v-if="loadingFormPaymentLimitation"></b-spinner>
              <span v-else>Save</span>
            </b-button>
            <b-button v-else variant="primary" :disabled="loadingFormPaymentLimitation" @click="createPaymentLimitation()"
              block size="lg">
              <b-spinner v-if="loadingFormPaymentLimitation"></b-spinner>
              <span v-else>Create</span>
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
    <claim-pin-verification
      :showModal="modalFormPINVerificationShow"
      @close-pin-verification="closePINVerification"
      @after-submit-pin-verification="afterSubmitPINVerification">
    </claim-pin-verification>
  </div>
</template>

<script>
import claimPinVerification from "../../component/ClaimPINVerification.vue";

export default {
  components: { claimPinVerification },
  data() {
    return {
      filter: "",
      sortBy: null,
      sortDesc: true,
      sortDirection: "asc",
      fromPage: [],
      toPage: [],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      fields: [
        {
          key: "username",
          label: "Username",
          sortable: false,
          class: "text-left"
        },
        {
          key: "amount_limit",
          label: "Claim Limit",
          sortable: false,
          class: "text-left"
        },
        {
          key: "reached_max",
          label: "Reached Max?",
          sortable: false,
          class: "text-left w-10"
        },
        { key: "action", label: "Action", class: "text-left w-10" }
      ],
      payment_limitation: {
        id: "",
        user_id: "",
        username: "",
        amount_limit: "",
        user_type: "",
      },
      user_types: [
        {text: "Claim Agent", value: "claim"},
        {text: "Claim Manager", value: "claim_manager"},
        {text: "Super Admin", value: "superadmin"}
      ],
      payment_limitations : [],
      claim_users: [],
      editModal: false,
      modalFormPaymentLimitationShow: false,
      loadingFormPaymentLimitation: false,
      modalFormPINVerificationShow: false,
      pinVerificationFor: "createPaymentLimitation",
      deletedPaymentLimitationId: "",
    }
  },
  beforeCreate() {
    this.$store
      .dispatch("ClaimSettingPaymentLimitationModule/getClaimUsers")
      .then((response) => {
        this.claim_users = response.data.data;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  methods: {
    parsingUserTypes(userType) {
      const userTypeResult = this.user_types.find((el) => el.value == userType)
      if (userTypeResult) {
        return userTypeResult.text
      }

      return ""
    },
    getDataPaymentLimitation(ctx, callback) {
      const vm = this;
      const formData = new FormData();
      formData.append("search_param", ctx.filter);
      formData.append("limit", ctx.perPage);
      formData.append("page", ctx.currentPage);
      formData.append("sort_by", ctx.sortBy);
      formData.append("is_sort_asc", false);
      this.$store
        .dispatch("ClaimSettingPaymentLimitationModule/getAllPaymentLimitationWithPaging", formData)
        .then(response => {
          vm.totalRows = response.data.data.total_record;
          var from = [];
          var to = [];
          var sum = 0;
          for (let i = 1; i <= vm.currentPage; i++) {
            sum = i * vm.perPage;
            if (vm.totalRows <= sum) {
              from.push(sum - vm.perPage + 1);
              to.push(vm.totalRows - sum + sum);
            } else {
              from.push(sum - vm.perPage + 1);
              to.push(sum);
            }
          }
          this.fromPage = from;
          this.toPage = to;
          this.payment_limitations = response.data.data.results || [];
          callback(this.payment_limitations);
        })
        .catch(error => {
          this.$swal({
            type: "error",
            title: "Error!",
            text: error.response ? error.response.data.message : "Failed get payment limitations",
            showConfirmButton: false,
            timer: 1500,
          });
          callback([]);
        });
      return null;
    },
    showModalFormPaymentLimitation(action, id) {
      this.payment_limitation = {
        id: "",
        user_id: "",
        username: "",
        amount_limit: "",
        user_type: "",
      };

      if (action == 'edit') {
        this.$store
        .dispatch("ClaimSettingPaymentLimitationModule/getPaymentLimitation", id)
        .then(response => {
          let data = {...response.data.data}
          this.payment_limitation.id = data.id;
          this.payment_limitation.user_id = data.user_id;
          this.payment_limitation.username = data.username;
          this.payment_limitation.user_type = data.user_type;
        })
        .catch(error => {
          console.log(error);
        });

        this.editModal = true;
      } else {
        this.editModal = false;
      }

      this.modalFormPaymentLimitationShow = !this.modalFormPaymentLimitationShow;
    },
    closePINVerification() {
      this.loadingFormPaymentLimitation = false;
      this.modalFormPINVerificationShow = !this.modalFormPINVerificationShow;
    },
    afterSubmitPINVerification() {
      switch(this.pinVerificationFor) {
        case "createPaymentLimitation":
          this.submitCreatePaymentLimitation();
          break;
        case "updatePaymentLimitation":
          this.submitUpdatePaymentLimitation();
          break;
        case "deletePaymentLimitation":
          this.submitDeletePaymentLimitation();
          break;
      }
    },
    createPaymentLimitation() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.pinVerificationFor = "createPaymentLimitation"
          this.loadingFormPaymentLimitation = true;
          this.modalFormPINVerificationShow = true;
        } else {
          this.$swal("ERROR!", "Your data can not be submitted.", "warning");
        }
      });
    },
    submitCreatePaymentLimitation() {
      this.modalFormPINVerificationShow = !this.modalFormPINVerificationShow;
      const formData = new FormData();
      formData.append("user_id", this.payment_limitation.user_id);
      formData.append("username", this.payment_limitation.username);
      formData.append("amount_limit", this.payment_limitation.amount_limit);
      formData.append("user_type", this.payment_limitation.user_type);
      this.$store
        .dispatch("ClaimSettingPaymentLimitationModule/createPaymentLimitation", formData)
        .then((response) => {
          this.loadingFormPaymentLimitation = false;
          this.$swal({
            type: "success",
            title: "Your work has been saved",
            showConfirmButton: false,
            scrollbarPadding: false,
            timer: 1500,
          });
          this.modalFormPaymentLimitationShow = false;
          this.$refs.paymentLimitationTable.refresh();
        })
        .catch((error) => {
          this.$swal({
            type: "error",
            title: "Oops...",
            text: error.response ? error.response.data.data : "Failed store Payment Limitation",
            showConfirmButton: false,
            scrollbarPadding: false,
            timer: 1500,
          });
          this.loadingFormPaymentLimitation = false;
        });
    },
    updatePaymentLimitation() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.pinVerificationFor = "updatePaymentLimitation"
          this.loadingFormPaymentLimitation = true;
          this.modalFormPINVerificationShow = true;
        } else {
          this.$swal("ERROR!", "Your data can not be submitted.", "warning");
        }
      });
    },
    submitUpdatePaymentLimitation() {
      this.modalFormPINVerificationShow = !this.modalFormPINVerificationShow;
      const formData = new FormData();
        formData.append("user_id", this.payment_limitation.user_id);
        formData.append("username", this.payment_limitation.username);
        formData.append("amount_limit", this.payment_limitation.amount_limit);
        formData.append("user_type", this.payment_limitation.user_type);
        this.$store
          .dispatch("ClaimSettingPaymentLimitationModule/updatePaymentLimitation", {
            id: this.payment_limitation.id,
            formData
          })
          .then((response) => {
            this.loadingFormPaymentLimitation = false;
            this.$swal({
              type: "success",
              title: "Your work has been saved",
              showConfirmButton: false,
              scrollbarPadding: false,
              timer: 1500,
            });
            this.modalFormPaymentLimitationShow = false;
            this.$refs.paymentLimitationTable.refresh();
          })
          .catch((error) => {
            this.$swal({
              type: "error",
              title: "Oops...",
              text: error.response ? error.response.data.data : "Failed edit Payment Limitation",
              showConfirmButton: false,
              scrollbarPadding: false,
              timer: 1500,
            });
            this.loadingFormPaymentLimitation = false;
          });
    },
    deletePaymentLimitation(id, username) {
      this.pinVerificationFor = "deletePaymentLimitation"
      this.modalFormPINVerificationShow = true;
      this.deletedPaymentLimitationId = id;
    },
    submitDeletePaymentLimitation() {
      this.modalFormPINVerificationShow = !this.modalFormPINVerificationShow;
      this.$store.dispatch("ClaimSettingPaymentLimitationModule/deletePaymentLimitation", this.deletedPaymentLimitationId)
        .then((response) => {
          this.$swal("Deleted!", "Your data has been deleted.", "success");
          this.$refs.paymentLimitationTable.refresh();
        })
        .catch((error) => {
          this.$swal({
            type: "error",
            title: "Oops...",
            text: error.response ? error.response.data.message : "Failed to delete",
            showConfirmButton: false,
            scrollbarPadding: false,
            timer: 1500,
          });
        });
        this.deletedPaymentLimitationId = "";
    },
    updateUser(e) {
      if(e) {
        const claim_user = this.claim_users.find((el) => el.Id == e)
        if (claim_user) {
          this.payment_limitation.username = claim_user.username
          this.payment_limitation.user_type = claim_user.role 
        }
      }
    },
  }
};
</script>
<style scoped>
.custom-input-group-append {
  display: inline-block;
  vertical-align: middle;
  background-color: #ffffff;
  border: 1px solid #d1d3e2;
  border-left: none;
  vertical-align: middle;
  text-align: center;
  padding: 0.375rem 0.75rem;
  line-height: 1.5;
  font-size: 1rem;
  border-radius: 0.35rem;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.custom-input-group-append:hover {
  color: #2c3e50;
  cursor: unset;
}
.custom-input-group-prepend {
  display: inline-block;
  vertical-align: middle;
  background-color: #ffffff;
  border: 1px solid #d1d3e2;
  border-right: none;
  vertical-align: middle;
  text-align: center;
  padding: 0.375rem 0.75rem;
  line-height: 1.5;
  font-size: 1rem;
  border-radius: 0.35rem;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.custom-input-group-prepend:hover {
  color: #2c3e50;
  cursor: unset;
}
.custom-input-group-prepend.is-invalid {
  border-color: #e74a3b;
}
.custom-input-group-append.is-invalid {
  border-color: #e74a3b;
}
.custom-input-group-prepend.is-valid {
  border-color: #1cc88a;
}
.custom-input-group-append.is-valid {
  border-color: #1cc88a;
}
.custom-disabled-color {
  background-color: #eaecf4;
  border-color: #d1d3e2 !important;
}
</style>
